import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { setPosition } from './actions';

class Position extends Component {
  componentDidMount() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.props.setPosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    }, (error) => {
      // eslint-disable-next-line no-console
      console.log('Location unavailable: ', error);
    });
  }
  render() { return null; }
}
Position.propTypes = {
  setPosition: PropTypes.func.isRequired,
};

const mapDispatchToProps = { setPosition };

export default connect(null, mapDispatchToProps)(Position);



// WEBPACK FOOTER //
// ./src/app/position/Position.js